import { render, staticRenderFns } from "./Configs.vue?vue&type=template&id=6ca76e43&"
import script from "./Configs.vue?vue&type=script&lang=js&"
export * from "./Configs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports